import { Controller } from "@hotwired/stimulus"

// Adds .docked once the user has scrolled past ~70vh — flips nav from
// transparent-over-dark-hero to translucent paper.
export default class extends Controller {
  connect() {
    this.onScroll = this.onScroll.bind(this)
    this.onScroll()
    window.addEventListener("scroll", this.onScroll, { passive: true })
    window.addEventListener("resize", this.onScroll, { passive: true })
  }

  disconnect() {
    window.removeEventListener("scroll", this.onScroll)
    window.removeEventListener("resize", this.onScroll)
  }

  onScroll() {
    const threshold = window.innerHeight * 0.7
    this.element.classList.toggle("docked", window.scrollY > threshold)
  }
}
